import { render } from "./WCDesktopArrowCarousel.vue?vue&type=template&id=40fceb68&scoped=true&ts=true"
import script from "./WCDesktopArrowCarousel.vue?vue&type=script&lang=ts"
export * from "./WCDesktopArrowCarousel.vue?vue&type=script&lang=ts"

import "./WCDesktopArrowCarousel.vue?vue&type=style&index=0&id=40fceb68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fceb68"]])

export default __exports__